import React, { useState } from 'react'

const AddToPlaylist = ({ color = '#fff', hoverColor = '#bbfa33', imgClass = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={imgClass}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      viewBox="0 0 22.45 15.715"
    >
      <path
        data-name="Path 933"
        d="M2 5h13.47v2.245H2z"
        transform="translate(-2 -5)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
      <path
        data-name="Path 934"
        d="M2 9h13.47v2.245H2z"
        transform="translate(-2 -4.51)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
      <path
        data-name="Path 935"
        d="M10.98 13H2v2.245h8.98z"
        transform="translate(-2 -4.02)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
      <path
        data-name="Path 936"
        d="M16.49 9h2.245v4.49h4.49v2.245h-4.49v4.49H16.49v-4.49H12V13.49h4.49z"
        transform="translate(-.775 -4.51)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
    </svg>
  )
}

export default AddToPlaylist
